import React from 'react';
import { User } from 'firebase/auth';
import { signOutUser } from '../../services/auth';
import HandoffShell, { HandoffLink } from './HandoffShell';

interface NotWhitelistedNoticeProps {
    user: User;
}

/**
 * Shown to a verified account that isn't on the closed-beta whitelist. Unlike
 * VerifyEmailNotice there's no action the user can take to clear it — access is
 * granted by an admin adding the address — so this only explains and offers a
 * way out.
 */
function NotWhitelistedNotice({ user }: NotWhitelistedNoticeProps) {
    return (
        <HandoffShell
            label="Access not yet granted"
            detail="Organic Electronics is in closed beta."
            action={<HandoffLink onClick={() => signOutUser()}>Sign out</HandoffLink>}
        >
            <p className="max-w-[340px] text-[13px] leading-relaxed text-[rgba(42,40,36,0.55)]">
                <span className="text-ink-secondary">{user.email}</span> isn&rsquo;t on the access list yet. If
                you think this is a mistake, get in touch and we&rsquo;ll add your address.
            </p>
        </HandoffShell>
    );
}

export default NotWhitelistedNotice;
